<template>
  <div v-loading="formLoading">
     <!-- 资质列表 -->
     <div class="secondStep table_form_area">
      <el-form
        label-width=""
        class="demo-ruleForm"
        :model="newExtForm.subconQualificationsAndFilesBO"
        ref="ruleForm1"
      >
        <div class="title">
          <span></span>
          <div>资质列表</div>
        </div>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              :rules="qualificationListRule1"
              :model="newExtForm.subconQualificationsAndFilesBO.subconQualificationsBOS"
              label-width=""
              label=""
              prop="list"
            >
              <qualificationList
                :extTable="newExtForm.subconQualificationsAndFilesBO.subconQualificationsBOS"
                ref="qualificationList1"
              ></qualificationList>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              ref="uplodFile1"
              :rules="rules1.subconFileinfoBOS"
              prop="subconFileinfoBOS"
              label-width="110px"
              label="资质证书附件："
            >
              <qualificationCertificate
                :uploadUrl="
                  newExtForm.subconQualificationsAndFilesBO.subconFileinfoBOS &&
                  newExtForm.subconQualificationsAndFilesBO.subconFileinfoBOS.length
                    ? newExtForm.subconQualificationsAndFilesBO.subconFileinfoBOS[0]
                    : ''
                "
                @qualifications="qualifications"
              ></qualificationCertificate>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="1195px !important"></el-row>
      </el-form>
    </div>
    <!-- 技术人员 -->
    <div class="secondStep table_form_area">
      <el-form
        label-width=""
        class="demo-ruleForm"
        :model="newExtForm"
        :rules="rules2"
        ref="ruleForm2"
      >
        <div class="title">
          <span></span>
          <div>技术能力</div>
        </div>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation form_area">
            <el-form-item
              label-width="151px"
              label="施工核心技术及特长："
              prop="subconBaseInfo.coreAndExpertise"
              :rules="rules2.coreAndExpertise"
            >
            <el-input
              v-model="newExtForm.subconBaseInfo.coreAndExpertise"
              type="textarea"
              :rows="3"
              placeholder="请输入施工核心技术及特长"
              maxlength="255"
            ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              :rules="qualificationListRule2"
              :model="newExtForm.subconManagePersonAndFilesBO.subconManagePersonBOs"
              label-width=""
              label=""
              prop="list"
            >
              <technicalPersonnelInfo
                :extTable="newExtForm.subconManagePersonAndFilesBO.subconManagePersonBOs"
                ref="qualificationList2"
              ></technicalPersonnelInfo>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              required
              :error="error1"
              label-width="110px"
              label="工程业绩附件："
            >
            <!-- <upload
              :uploadUrl="newExtForm.technicalCapabilities.technicalPersonnelInformation[0].attribute10"
              @uploadUrl="getUrl1"
            ></upload> -->
              <qualificationCertificate
                :uploadUrl="
                  jsryxxFiles.gcyj ? jsryxxFiles.gcyj : ''
                "
                @qualifications="(url) => qualifications1(url,1)"
              ></qualificationCertificate>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              required
              :error="error2"
              label-width="110px"
              label="社保证明附件："
            >
              <qualificationCertificate
                :uploadUrl="
                  jsryxxFiles.sbzm ? jsryxxFiles.sbzm : ''
                "
                @qualifications="(url) => qualifications1(url,2)"
              ></qualificationCertificate>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              required
              :error="error3"
              label-width="110px"
              label="劳动合同附件："
            >
              <qualificationCertificate
                :uploadUrl="
                  jsryxxFiles.ldht ? jsryxxFiles.ldht : ''
                "
                @qualifications="(url) => qualifications1(url,3)"
              ></qualificationCertificate>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              :rules="qualificationListRule3"
              :model="newExtForm.subconAwardBOS"
              label-width=""
              label=""
              prop="list"
            >
              <awardsInfo
                :extTable="newExtForm.subconAwardBOS"
                ref="qualificationList3"
              ></awardsInfo>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="1195px !important"></el-row>
      </el-form>
    </div>
      <!-- 生产能力 -->
      <div class="secondStep table_form_area">
      <el-form
        label-width=""
        class="demo-ruleForm"
        :model="newExtForm"
        ref="ruleForm3"
      >
        <div class="title">
          <span></span>
          <div>生产能力</div>
        </div>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              :rules="qualificationListRule4"
              :model="newExtForm.subconcertificatedPersonAndFilesBO.subconManagePersonBOs"
              label-width=""
              label=""
              prop="list"
            >
              <personnelInfo
                :extTable="newExtForm.subconcertificatedPersonAndFilesBO.subconManagePersonBOs"
                tableTitle="持证管理人员"
                ref="qualificationList4"
              ></personnelInfo>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              required
              :error="error4"
              label-width="110px"
              label="工程业绩附件："
            >
            <!-- <upload
              :uploadUrl="newExtForm.technicalCapabilities.technicalPersonnelInformation[0].attribute10"
              @uploadUrl="getUrl1"
            ></upload> -->
              <qualificationCertificate
                :uploadUrl="
                  czglryFiles.gcyj ? czglryFiles.gcyj : ''
                "
                @qualifications="(url) => qualifications2(url,1)"
              ></qualificationCertificate>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              required
              :error="error5"
              label-width="110px"
              label="社保证明附件："
            >
              <qualificationCertificate
                :uploadUrl="
                  czglryFiles.sbzm ? czglryFiles.sbzm : ''
                "
                @qualifications="(url) => qualifications2(url,2)"
              ></qualificationCertificate>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              required
              :error="error6"
              label-width="110px"
              label="劳动合同附件："
            >
              <qualificationCertificate
                :uploadUrl="
                 czglryFiles.ldht ? czglryFiles.ldht : ''
                "
                @qualifications="(url) => qualifications2(url,3)"
              ></qualificationCertificate>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              :rules="qualificationListRule5"
              :mode="newExtForm.subconToDoPersonAndFilesBO.subconManagePersonBOs"
              label-width=""
              label=""
              prop="list"
            >
              <personnelInfo
                :extTable="newExtForm.subconToDoPersonAndFilesBO.subconManagePersonBOs"
                tableTitle="作业班组"
                ref="qualificationList5"
              ></personnelInfo>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              required
              :error="error7"
              label-width="110px"
              label="工程业绩附件："
            >
            <!-- <upload
              :uploadUrl="newExtForm.technicalCapabilities.technicalPersonnelInformation[0].attribute10"
              @uploadUrl="getUrl1"
            ></upload> -->
              <qualificationCertificate
                :uploadUrl="
                  zybzFiles.gcyj ? zybzFiles.gcyj : ''
                "
                @qualifications="(url) => qualifications3(url,1)"
              ></qualificationCertificate>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              required
              :error="error8"
              label-width="110px"
              label="社保证明附件："
            >
              <qualificationCertificate
                :uploadUrl="
                  zybzFiles.sbzm ? zybzFiles.sbzm : ''
                "
                @qualifications="(url) => qualifications3(url,2)"
              ></qualificationCertificate>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              required
              :error="error9"
              label-width="110px"
              label="劳动合同附件："
            >
              <qualificationCertificate
                :uploadUrl="
                  zybzFiles.ldht ? zybzFiles.ldht : ''
                "
                @qualifications="(url) => qualifications3(url,3)"
              ></qualificationCertificate>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              :rules="qualificationListRule6"
              :mode="newExtForm.subconProductiveCapacityBOS"
              label-width=""
              label=""
              prop="list"
            >
              <annualProductionCapacity
                :extTable="newExtForm.subconProductiveCapacityBOS"
                ref="qualificationList6"
              ></annualProductionCapacity>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item prop="list" :model="newExtForm.subconDeviceInfoPOS"  :rules="qualificationListRule7">
              <majorEquipment
                ref="qualificationList7"
                :extTable="newExtForm.subconDeviceInfoPOS"
              ></majorEquipment>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              ref="uplodFile2"
              label-width="82px"
              label="周转材料："
              prop="subconBaseInfo.turnoverMaterial"
              :rules="rules3.turnoverMaterial"
            >
              <qualificationCertificate
                :uploadUrl="thirdFiles.zzcl"
                @qualifications="qualifications4"
              ></qualificationCertificate>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="1195px !important"></el-row>
      </el-form>
    </div>
     <!-- 履约能力 -->
     <div class="secondStep table_form_area">
      <el-form
        label-width=""
        class="demo-ruleForm"
        :model="newExtForm"
        ref="ruleForm4"
      >
        <div class="title">
          <span></span>
          <div>履约能力</div>
        </div>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              :rules="qualificationListRule8"
              :mode="newExtForm.subconCooPfeBOS"
              label-width=""
              label=""
              prop="list"
            >
              <performanceCapability
                :extTable="newExtForm.subconCooPfeBOS"
                ref="qualificationList8"
              ></performanceCapability>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" class="addTabIndex deviation">
            <el-form-item
              ref="uplodFile3"
              :rules="rules4.informationOfPoliticalReview"
              prop="subconBaseInfo.informationOfPoliticalReview"
              label-width="82px"
              label="政审材料："
            >
              <qualificationCertificate
                :uploadUrl="thirdFiles.zscl"
                @qualifications="qualifications5"
              ></qualificationCertificate>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="1195px !important"></el-row>
      </el-form>
    </div>
     <!-- 底部按钮 -->
     <div class="secondStep buttons">
      <el-form
        label-width=""
        class="demo-ruleForm"
        :model="{}"
        ref="buttons"
      >
        <el-row style="1195px !important"></el-row>
        <el-form-item>
          <el-button @click="submitForm('ruleForm')">提交</el-button>
          <el-button class="stopBtn" @click="saveForm()">暂存</el-button>
          <el-button class="lastBtn" @click="lastStep('ruleForm')"
            >上一步</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { dealSubconRegister } from "@/api/subcontractor-register";
import upload from "../components/upload.vue";
// 上传附件
import qualificationCertificate from "../components/qualificationCertificate.vue";
// 资历列表
import qualificationList from "../components/qualificationList.vue";
// 技术人员
import technicalPersonnelInfo from "../components/technicalPersonnelInfo.vue";
// 获奖情况
import awardsInfo from "../components/awardsInfo.vue";
// 持证管理人员  作业班组
import personnelInfo from "../components/personnelInfo.vue";
// 年生产能力
import annualProductionCapacity from "../components/annualProductionCapacity.vue";
// 主要设备
import majorEquipment from "../components/majorEquipment.vue";
// 履约能力
import performanceCapability from "../components/performanceCapability.vue";
export default {
  components: {
    upload,
    qualificationCertificate,
    qualificationList,
    technicalPersonnelInfo,
    awardsInfo,
    personnelInfo,
    annualProductionCapacity,
    majorEquipment,
    performanceCapability
  },
  props: {
    thirdStepId: "",
    extForm: {
      type: Object,
      default: () => {
        return {};
      }
    },
    extTable: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      formLoading: false,
      newExtForm: this.extForm,
      qualificationListRule: {
        list: [
          { required: true, message: "资历列表不能为空", trigger: "change" }
        ]
      },
      qualificationListRule1: {
        list: [
          { required: true, message: "资历列表不能为空", trigger: "change" }
        ]
      },
      qualificationListRule2: {
        list: [
          { required: true, message: "技术人员信息不能为空", trigger: "change" }
        ]
      },
      qualificationListRule3: {
        list: [
          { required: true, message: "获奖情况不能为空", trigger: "change" }
        ]
      },
      qualificationListRule4: {
        list: [
          { required: true, message: "持证管理人员不能为空", trigger: "change" }
        ]
      },
      qualificationListRule5: {
        list: [
          { required: true, message: "作业班组不能为空", trigger: "change" }
        ]
      },
      qualificationListRule6: {
        list: [
          { required: true, message: "年生产能力不能为空", trigger: "change" }
        ]
      },
      qualificationListRule7: {
        list: [
          { required: true, message: "主要设备不能为空", trigger: "change" }
        ]
      },
      qualificationListRule8: {
        list: [
          { required: true, message: "履约能力不能为空", trigger: "change" }
        ]
      },
      rules1: {
        subconFileinfoBOS: [
          {
            type: "array",
            required: true,
            message: "请上传资质证书附件",
            trigger: "change"
          }
        ],
      },
      rules2: {
        coreAndExpertise: [
          { required: true, message: "请输入施工核心技术及特长", trigger: "blur" }
        ],
      },
      rules3: {
        turnoverMaterial: [
          {
            required: true,
            message: "请上传周转材料附件",
            trigger: "change"
          }
        ],
      },
      rules4: {
        informationOfPoliticalReview: [
          {
            required: true,
            message: "请上传政审材料附件",
            trigger: "change"
          }
        ],
      },
      rules: {
        // 资质信息
        accountBank: [
          { required: true, message: "请输入开户银行", trigger: "blur" }
        ],
        billingAddress: [
          { required: true, message: "请输入开票地址", trigger: "blur" }
        ],
        billingPhone: [
          { required: true, message: "请输入开票电话", trigger: "blur" }
        ],
        bankNumber: [
          { required: true, message: "请输入银行账号", trigger: "blur" },
          // 一般由6－12位数字组成。最多可以使用12位数字。
          {
            //pattern: /^([1-9]{1})(\d{14}|\d{18})$/,
            pattern: /^[0-9]\d*$/,
            message: "银行卡号不正确"
          }
        ]
      },
      majorEquipmentRules: {
        list: [
          { required: true, message: "设备类表不能为空", trigger: "change" }
        ]
      },
      qualificationListRule: {
        list: [
          { required: true, message: "资历列表不能为空", trigger: "change" }
        ]
      },
      // 技术人员
      jsryxxFiles: {
        gcyj: null,
        sbzm: null,
        ldht: null
      },
      // 持证管理人员
      czglryFiles: {
        gcyj: null,
        sbzm: null,
        ldht: null
      },
      // 作业班组
      zybzFiles: {
        gcyj: null,
        sbzm: null,
        ldht: null
      },
      // rules1: {
      //   speciality: [
      //     { required: true, message: "施工核心技术及特长不能为空", trigger: "blur" }
      //   ],
        // projects: [
        //   {
        //     required: true,
        //     message: "请上传工程业绩附件",
        //     trigger: ["blur", "change"]
        //   }
        // ],
        // socialSecurityFile: [
        //   {
        //     required: true,
        //     message: "请上传社保证明附件",
        //     trigger: ["blur", "change"]
        //   }
        // ],
        // laborContract: [
        //   {
        //     required: true,
        //     message: "请上传劳动合同附件",
        //     trigger: ["blur", "change"]
        //   }
        // ],
        // bankNumber: [
        //   { required: true, message: "请输入银行账号", trigger: "blur" },
        //   // 一般由6－12位数字组成。最多可以使用12位数字。
        //   {
        //     pattern: /[1-9]\d{12,18}/,
        //     message: "银行卡号不正确",
        //   },
        // ],
      // }
      thirdFiles: {
        zzcl: null,
        zscl: null
      },
      formTip: {},
      error1: "",
      error2: "",
      error3: "",
      error4: "",
      error5: "",
      error6: "",
      error7: "",
      error8: "",
      error9: "",
    };
  },
  mounted() {
    
  },
  created(){
    this.setFiles();
  },
  methods: {
    // 附件校验
    gcyjValid1() {
      if(!this.jsryxxFiles.gcyj){
        this.error1 = "工程业绩附件不能为空"
        return false
      }else {
        this.error1 = ""
        return true
      }
    },
    gcyjValid2() {
      if(!this.jsryxxFiles.sbzm){
        this.error2 = "社保证明附件不能为空"
        return false
      }else {
        this.error2 = ""
        return true
      }
    },
    gcyjValid3() {
      if(!this.jsryxxFiles.ldht){
        this.error3 = "工程业绩附件不能为空"
        return false
      }else {
        this.error3 = ""
        return true
      }
    },
    gcyjValid4() {
      if(!this.czglryFiles.gcyj){
        this.error4 = "工程业绩附件不能为空"
        return false
      }else {
        this.error4 = ""
        return true
      }
    },
    gcyjValid5() {
      if(!this.czglryFiles.sbzm){
        this.error5 = "社保证明附件不能为空"
        return false
      }else {
        this.error5 = ""
        return true
      }
    },
    gcyjValid6() {
      if(!this.czglryFiles.ldht){
        this.error6 = "工程业绩附件不能为空"
        return false
      }else {
        this.error6 = ""
        return true
      }
    },
    gcyjValid7() {
      if(!this.zybzFiles.gcyj){
        this.error7 = "工程业绩附件不能为空"
        return false
      }else {
        this.error7 = ""
        return true
      }
    },
    gcyjValid8() {
      if(!this.zybzFiles.sbzm){
        this.error8 = "社保证明附件不能为空"
        return false
      }else {
        this.error8 = ""
        return true
      }
    },
    gcyjValid9() {
      if(!this.zybzFiles.ldht){
        this.error9 = "工程业绩附件不能为空"
        return false
      }else {
        this.error9 = ""
        return true
      }
    },
    setFiles(){
      let files = this.extForm.subconBaseFileinfoBOS
      files.forEach(item => {
        switch (item.businessFileType){
          case "18":
            this.thirdFiles.zzcl = item;
            break;
          case "17":
            this.thirdFiles.zscl = item;
            break;
        }
      })
      let jsry = this.newExtForm.subconManagePersonAndFilesBO.subconFileinfoBOS;
      let czglry = this.newExtForm.subconcertificatedPersonAndFilesBO.subconFileinfoBOS;
      let zybz = this.newExtForm.subconToDoPersonAndFilesBO.subconFileinfoBOS
      if(jsry.length > 0){
        jsry.forEach(item => {
          if(item.businessFileType == "16"){
            this.jsryxxFiles.gcyj = item
          }else if(item.businessFileType == "15") {
            this.jsryxxFiles.sbzm = item
          }else if(item.businessFileType == "14") {
            this.jsryxxFiles.ldht = item
          }
        })
      }
      if(czglry.length > 0){
        czglry.forEach(item => {
          if(item.businessFileType == "21"){
            this.czglryFiles.gcyj = item
          }else if(item.businessFileType == "20") {
            this.czglryFiles.sbzm = item
          }else if(item.businessFileType == "19") {
            this.czglryFiles.ldht = item
          }
        })
      }
      if(zybz.length > 0){
        zybz.forEach(item => {
          if(item.businessFileType == "24"){
            this.zybzFiles.gcyj = item
          }else if(item.businessFileType == "23") {
            this.zybzFiles.sbzm = item
          }else if(item.businessFileType == "22") {
            this.zybzFiles.ldht = item
          }
        })
      }
    },
    lastStep() {
      this.$emit("getStep", 1);
    },
    qualifications(url) {
      if (
        this.newExtForm.subconQualificationsAndFilesBO.subconQualificationsBOS &&
        this.newExtForm.subconQualificationsAndFilesBO.subconQualificationsBOS.length <= 0
      ) {
        this.newExtForm.subconQualificationsAndFilesBO.subconQualificationsBOS.push({
          id: 1
        });
      }
      if(url){
        this.newExtForm.subconQualificationsAndFilesBO.subconFileinfoBOS[0] = url;
        this.$refs.uplodFile1.clearValidate()
      }else {
        this.newExtForm.subconQualificationsAndFilesBO.subconFileinfoBOS = []
      }
    },
    qualifications1(url, flag) {
      if (
        this.newExtForm.subconManagePersonAndFilesBO.subconManagePersonBOs &&
        this.newExtForm.subconManagePersonAndFilesBO.subconManagePersonBOs.length <= 0
      ) {
        this.newExtForm.subconManagePersonAndFilesBO.subconManagePersonBOs.push({
          id: 1,
          attribute1: "04"
        });
      }
      if(flag == 1){
        if(url){
          url.businessFileType = "16"
          this.newExtForm.subconManagePersonAndFilesBO.subconFileinfoBOS.push(url);
          this.jsryxxFiles.gcyj = url;
          this.gcyjValid1();
        }else {
          this.newExtForm.subconManagePersonAndFilesBO.subconFileinfoBOS = this.newExtForm.subconManagePersonAndFilesBO.subconFileinfoBOS.filter(item => item.businessFileType !== "16")
          this.jsryxxFiles.gcyj = null;
        }
      }else if(flag == 2) {
        if(url){
          url.businessFileType = "15"
          this.newExtForm.subconManagePersonAndFilesBO.subconFileinfoBOS.push(url)
          this.jsryxxFiles.sbzm = url;
          this.gcyjValid2();
        }else {
          this.newExtForm.subconManagePersonAndFilesBO.subconFileinfoBOS = this.newExtForm.subconManagePersonAndFilesBO.subconFileinfoBOS.filter(item => item.businessFileType !== "15")
          this.jsryxxFiles.sbzm = null;
        }
      }else if(flag == 3) {
        if(url){
          url.businessFileType = "14"
          this.newExtForm.subconManagePersonAndFilesBO.subconFileinfoBOS.push(url);
          this.jsryxxFiles.ldht = url;
          this.gcyjValid3();
        }else {
          this.newExtForm.subconManagePersonAndFilesBO.subconFileinfoBOS = this.newExtForm.subconManagePersonAndFilesBO.subconFileinfoBOS.filter(item => item.businessFileType !== "14")
          this.jsryxxFiles.ldht = null;
        }
      }
    },
    qualifications2(url, flag) {
      if (
        this.newExtForm.subconcertificatedPersonAndFilesBO.subconManagePersonBOs &&
        this.newExtForm.subconcertificatedPersonAndFilesBO.subconManagePersonBOs.length <= 0
      ) {
        this.newExtForm.subconcertificatedPersonAndFilesBO.subconManagePersonBOs.push({
          id: 1,
          attribute1: "05"
        });
      }
      // this.newExtForm.subconQualificationsChange[0].qualificationEnclosure = url;
      if(flag == 1){
        if(url){
          url.businessFileType = "21"
          this.newExtForm.subconcertificatedPersonAndFilesBO.subconFileinfoBOS.push(url);
          this.czglryFiles.gcyj = url
          this.gcyjValid4();
        }else {
          this.newExtForm.subconcertificatedPersonAndFilesBO.subconFileinfoBOS = this.newExtForm.subconcertificatedPersonAndFilesBO.subconFileinfoBOS.filter(item => item.businessFileType !== "21")
          this.czglryFiles.gcyj = null
        }
      }else if(flag == 2) {
        if(url){
          url.businessFileType = "20"
          this.newExtForm.subconcertificatedPersonAndFilesBO.subconFileinfoBOS.push(url)
          this.czglryFiles.sbzm = url
          this.gcyjValid5();
        }else {
          this.newExtForm.subconcertificatedPersonAndFilesBO.subconFileinfoBOS = this.newExtForm.subconcertificatedPersonAndFilesBO.subconFileinfoBOS.filter(item => item.businessFileType !== "20")
          this.czglryFiles.sbzm = null;
        }
      }else if(flag == 3) {
        if(url){
          url.businessFileType = "19"
          this.newExtForm.subconcertificatedPersonAndFilesBO.subconFileinfoBOS.push(url)
          this.czglryFiles.ldht = url
          this.gcyjValid6();
        }else {
          this.newExtForm.subconcertificatedPersonAndFilesBO.subconFileinfoBOS = this.newExtForm.subconcertificatedPersonAndFilesBO.subconFileinfoBOS.filter(item => item.businessFileType !== "19")
          this.czglryFiles.ldht = null
        }
      }
    },
    qualifications3(url, flag) {
      if (
        this.newExtForm.productionCapacity.operatives &&
        this.newExtForm.productionCapacity.operatives.length <= 0
      ) {
        this.newExtForm.productionCapacity.operatives.push({
          id: 1,
          attribute1: "06"
        });
      }
      if(flag == 1){
        if(url){
          url.businessFileType = "24"
          this.newExtForm.subconToDoPersonAndFilesBO.subconFileinfoBOS.push(url);
          this.zybzFiles.gcyj = url
          this.gcyjValid7();
        }else {
          this.newExtForm.subconToDoPersonAndFilesBO.subconFileinfoBOS = this.newExtForm.subconToDoPersonAndFilesBO.subconFileinfoBOS.filter(item => item.businessFileType !== "24")
          this.zybzFiles.gcyj = null;
        }
      }else if(flag == 2) {
        if(url){
          url.businessFileType = "23"
          this.newExtForm.subconToDoPersonAndFilesBO.subconFileinfoBOS.push(url)
          this.zybzFiles.sbzm = url
          this.gcyjValid8();
        }else {
          this.newExtForm.subconToDoPersonAndFilesBO.subconFileinfoBOS = this.newExtForm.subconToDoPersonAndFilesBO.subconFileinfoBOS.filter(item => item.businessFileType !== "23")
          this.zybzFiles.sbzm = null;
        }
      }else if(flag == 3) {
        if(url){
          url.businessFileType = "22"
          this.newExtForm.subconToDoPersonAndFilesBO.subconFileinfoBOS.push(url);
          this.zybzFiles.ldht = url
          this.gcyjValid9();
        }else {
          this.newExtForm.subconToDoPersonAndFilesBO.subconFileinfoBOS = this.newExtForm.subconToDoPersonAndFilesBO.subconFileinfoBOS.filter(item => item.businessFileType !== "22")
          this.zybzFiles.ldht = null;
        }
      }
    },
    qualifications4(url) {
      if (
        this.newExtForm.subconDeviceInfoChange &&
        this.newExtForm.subconDeviceInfoChange.length <= 0
      ) {
        this.newExtForm.subconDeviceInfoChange.push({
          id: 1
        });
      }
      if(url) {
        this.thirdFiles.zzcl = url
        this.newExtForm.subconBaseInfo.turnoverMaterial = url.uploadId;
        this.$refs.uplodFile2.clearValidate()
      }else {
        this.thirdFiles.zzcl = null
        this.newExtForm.subconBaseInfo.turnoverMaterial = "";
      }
    },
    qualifications5(url) {
      if (
        this.newExtForm.subconCooPfeChange &&
        this.newExtForm.subconCooPfeChange.length <= 0
      ) {
        this.newExtForm.subconCooPfeChange.push({
          id: 1
        });
      }
      if(url) {
        this.thirdFiles.zscl = url;
        this.newExtForm.subconBaseInfo.informationOfPoliticalReview = url.uploadId;
        this.$refs.uplodFile3.clearValidate()
      }else {
        this.thirdFiles.zscl = null;
        this.newExtForm.subconBaseInfo.informationOfPoliticalReview = "";
      }
    },

    getUrl1(url){
      this.newExtForm.subconManagePersonAndFilesBO.subconFileinfoBOS[0] = url;
    },
    // 获取事件
    getDate(dateData) {
      let date = new Date(dateData);
      let y = date.getFullYear();
      return y;
    },
    saveForm() {
      var that = this;
      this.formLoading = true;
      let params = {
        type: "1",
        subFlag: "0",
        checkState: 3,
        subconBaseInfoBO: this.newExtForm.subconBaseInfo,
        subconQualificationsAndFilesBO: this.newExtForm.subconQualificationsAndFilesBO,
        subconManagePersonAndFilesBO: this.newExtForm.subconManagePersonAndFilesBO,
        subconAwardBOS: this.newExtForm.subconAwardBOS,
        subconcertificatedPersonAndFilesBO: this.newExtForm.subconcertificatedPersonAndFilesBO,
        subconToDoPersonAndFilesBO: this.newExtForm.subconToDoPersonAndFilesBO,
        subconProductiveCapacityBOS: this.newExtForm.subconProductiveCapacityBOS,
        subconDeviceInfoBOS: this.newExtForm.subconDeviceInfoPOS,
        subconCooPfeBOS: this.newExtForm.subconCooPfeBOS,
        subconAuthAccountInfoBO: this.newExtForm.subconAuthAccountInfo,
        subconCooUnitInfoBO: this.newExtForm.subconCooUnitInfo,
      }
      dealSubconRegister(params).then(
        res => {
          this.formLoading = false;
          if (res.data.code === "0") {
            this.$message({
              showClose: true,
              type: "success",
              message: "暂存成功",
              ccuiCustom: true
            });
          } else {
            this.$message({
              showClose: true,
              type: "error",
              message: res.data.message,
              ccuiCustom: true
            });
          }
        },
        error => {
          this.formLoading = false;
        }
      );
    },
    submitForm(formName) {
      console.log(this.newExtForm)
      this.$refs.qualificationList1.ruleFun();  // 资质列表
      this.$refs.qualificationList2.ruleFun();  // 技术人员
      this.$refs.qualificationList3.ruleFun();  // 获奖情况
      this.$refs.qualificationList4.ruleFun();  // 持证管理人员
      this.$refs.qualificationList5.ruleFun();  // 作业班组
      this.$refs.qualificationList6.ruleFun();  // 年生产能力
      this.$refs.qualificationList7.ruleFun();  // 主要设备
      this.$refs.qualificationList8.ruleFun();  // 履约能力
      const p1 = new Promise((resolve, reject) => {
          this.$refs.ruleForm1.validate(valid => {
            if (valid) {
              this.formTip.flag1 = true;
              resolve();
            } else {
              this.$nextTick(() => {
                let isError = document.getElementsByClassName("is-error");
                isError[0].scrollIntoView({
                  block: "center",
                  behavior: "smooth",
                });
              });
              this.formTip.flag1 = false;
              return false
            }
          });
        });
        const p2 = new Promise((resolve, reject) => {
          this.$refs.ruleForm2.validate(valid => {
            let valid1 = this.gcyjValid1();
            let valid2 = this.gcyjValid2();
            let valid3 = this.gcyjValid3();
            if (valid1 && valid2 && valid2 && valid) {
              this.formTip.flag2 = true;
              resolve();
            } else {
              this.$nextTick(() => {
                let isError = document.getElementsByClassName("is-error");
                isError[0].scrollIntoView({
                  block: "center",
                  behavior: "smooth",
                });
              });
              this.formTip.flag2 = false;
              return false
            }
          });
        });
        const p3 = new Promise((resolve, reject) => {
          this.$refs.ruleForm3.validate(valid => {
            let valid4 = this.gcyjValid4();
            let valid5 = this.gcyjValid5();
            let valid6 = this.gcyjValid6();
            let valid7 = this.gcyjValid7();
            let valid8 = this.gcyjValid8();
            let valid9 = this.gcyjValid9();
            if (valid4 && valid5 && valid6 && valid7 && valid8 && valid9 && valid) {
              this.formTip.flag3 = true;
              resolve();
            } else {
              this.$nextTick(() => {
                let isError = document.getElementsByClassName("is-error");
                isError[0].scrollIntoView({
                  block: "center",
                  behavior: "smooth",
                });
              });
              this.formTip.flag3 = false;
              return false
            }
          });
        });
        const p4 = new Promise((resolve, reject) => {
          this.$refs.ruleForm4.validate(valid => {
            if (valid) {
              this.formTip.flag4 = true;
              resolve();
            } else {
              this.$nextTick(() => {
                let isError = document.getElementsByClassName("is-error");
                isError[0].scrollIntoView({
                  block: "center",
                  behavior: "smooth",
                });
              });
              this.formTip.flag4 = false;
              return false
            }
          });
        });
        let { flag1, flag2, flag3, flag4 } = this.formTip;
        if (!flag1 || !flag2 || !flag3 || !flag4) {
          this.$emit("open");
        }else {
          if (this.newExtForm.subconQualificationsAndFilesBO.subconQualificationsBOS.length <= 0) {
            this.$message({
              type: "warning",
              showClose: true,
              message: "资质列表不能为空",
              ccuiCustom: true
            });
            this.$refs.qualificationList1.$el.scrollIntoView({
              block: "center",
              behavior: "smooth",
            });
            return false;
          }
          if (this.newExtForm.subconManagePersonAndFilesBO.subconManagePersonBOs.length <= 0) {
            this.$message({
              type: "warning",
              showClose: true,
              message: "技术人员信息列表不能为空",
              ccuiCustom: true
            });
            this.$refs.qualificationList2.$el.scrollIntoView({
              block: "center",
              behavior: "smooth",
            });
            return false;
          }
          if (this.newExtForm.subconAwardBOS.length <= 0) {
            this.$message({
              type: "warning",
              showClose: true,
              message: "获奖情况列表不能为空",
              ccuiCustom: true
            });
            this.$refs.qualificationList3.$el.scrollIntoView({
              block: "end",
              behavior: "smooth",
            });
            return false;
          }
          if (this.newExtForm.subconcertificatedPersonAndFilesBO.subconManagePersonBOs.length <= 0) {
            this.$message({
              type: "warning",
              showClose: true,
              message: "持证管理人员列表不能为空",
              ccuiCustom: true
            });
            this.$refs.qualificationList4.$el.scrollIntoView({
              block: "end",
              behavior: "smooth",
            });
            return false;
          }
          if (this.newExtForm.subconToDoPersonAndFilesBO.subconManagePersonBOs.length <= 0) {
            this.$message({
              type: "warning",
              showClose: true,
              message: "作业班组列表不能为空",
              ccuiCustom: true
            });
            this.$refs.qualificationList5.$el.scrollIntoView({
              block: "end",
              behavior: "smooth",
            });
            return false;
          }
          if (this.newExtForm.subconProductiveCapacityBOS.length <= 0) {
            this.$message({
              type: "warning",
              showClose: true,
              message: "年生产能力列表不能为空",
              ccuiCustom: true
            });
            this.$refs.qualificationList6.$el.scrollIntoView({
              block: "end",
              behavior: "smooth",
            });
            return false;
          }
          if (this.newExtForm.subconDeviceInfoPOS.length <= 0) {
            this.$message({
              type: "warning",
              showClose: true,
              message: "主要设备列表不能为空",
              ccuiCustom: true
            });
            this.$refs.qualificationList7.$el.scrollIntoView({
              block: "end",
              behavior: "smooth",
            });
            return false;
          }
          if (this.newExtForm.subconCooPfeBOS.length <= 0) {
            this.$message({
              type: "warning",
              showClose: true,
              message: "履约能力列表不能为空",
              ccuiCustom: true
            });
            this.$refs.qualificationList8.$el.scrollIntoView({
              block: "end",
              behavior: "smooth",
            });
            return false;
          }
          if (this.$refs.qualificationList1.checkOut&&
            this.$refs.qualificationList2.checkOut&&
            this.$refs.qualificationList3.checkOut&&
            this.$refs.qualificationList4.checkOut&&
            this.$refs.qualificationList5.checkOut&&
            this.$refs.qualificationList6.checkOut&&
            this.$refs.qualificationList7.checkOut&&
            this.$refs.qualificationList8.checkOut){
          Promise.all([p1, p2, p3, p4]).then(async () => {
            this.formLoading = true;
            let params = {
              type: "1",
              subFlag: "1",
              checkState: 3,
              subconBaseInfoBO: this.newExtForm.subconBaseInfo,
              subconQualificationsAndFilesBO: this.newExtForm.subconQualificationsAndFilesBO,
              subconManagePersonAndFilesBO: this.newExtForm.subconManagePersonAndFilesBO,
              subconAwardBOS: this.newExtForm.subconAwardBOS,
              subconcertificatedPersonAndFilesBO: this.newExtForm.subconcertificatedPersonAndFilesBO,
              subconToDoPersonAndFilesBO: this.newExtForm.subconToDoPersonAndFilesBO,
              subconProductiveCapacityBOS: this.newExtForm.subconProductiveCapacityBOS,
              subconDeviceInfoBOS: this.newExtForm.subconDeviceInfoPOS,
              subconCooPfeBOS: this.newExtForm.subconCooPfeBOS,
              subconAuthAccountInfoBO: this.newExtForm.subconAuthAccountInfo,
              subconCooUnitInfoBO: this.newExtForm.subconCooUnitInfo,
            }
            dealSubconRegister(params).then(
              res => {
                this.formLoading = false;
                if (res.data.code === "0") {
                  this.$router.push("/subcon-submit-success");
                } else {
                  this.$message({
                    showClose: true,
                    type: "error",
                    message: res.data.message,
                    ccuiCustom: true,
                  });
                }
              },
              error => {
                this.formLoading = false;
              }
            );
          })
        }
      }
    },
  },
  watch: {}
};
</script>

<style lang="scss" scoped>
.secondStep{
  padding: 0 90px;
  .title {
    width: 100%;
    height: 50px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #000000;
    position: relative;
    line-height: 20px;
    span {
      margin-right: 16px;
      height: 20px;
      display: inline-block;
      width: 4px;
      background: #ff152e;
    }
    div {
      position: absolute;
      //   top: -2px;
      display: inline-block;
    }
  }
  
}
.form_area{
  /deep/ .el-form-item{
    margin-bottom: 30px;
    .el-select {
      width: 100%;
    }
    .el-input__inner {
      height: 40px !important;
    }
    .el-date-editor {
      width: 100%;
    } 
  }
}
.table_form_area {
  /deep/ .el-table__body .cell {
    overflow: visible;
    .el-form-item__error {
      padding-top: 0px;
    }
  }
}
.buttons {
  display: flex;
  justify-content: center;
    /deep/ .el-button {
    width: 82px;
    height: 40px;
    background: #ff152e;
    border-radius: 2px;
    font-size: 14px;
    border: none;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
  }
  .stopBtn {
    background: rgba(180, 111, 117, 0.08);
    border: 1px solid #ff152e;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ff152e;
  }
  .lastBtn {
    background: #fafafa;
    border: 1px solid #dddddd;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.25);
  }
}
</style>
